import { useState, useEffect } from 'react';
import { Files } from 'helpers/FileHelpers';
import { MediaList } from 'models/BaseModel';


export const usePhoto1Image = (fileList: any, setFileList: React.Dispatch<React.SetStateAction<any>>, setPhoto1Url: React.Dispatch<React.SetStateAction<string | null>>, setError: (error: string | null) => void) => {
  const [photo1Image, setPhoto1Image] = useState<File | null>(null);
  

  useEffect(() => {
    if (fileList?.photo1) {
      Files.ImageAPI.Load('photo1', fileList, Files.ImageAPI.Fetch, setPhoto1Url);
    }
  }, [fileList, setPhoto1Url]);

  const handlePhoto1ImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setPhoto1Image(event.target.files[0]);
    }
  };

  const handleAttachPhoto1Image = async () => {
    if (photo1Image) {
      const uploadedFile = await Files.ImageAPI.Attach(photo1Image, 200, setError);
      setFileList((prevFileList: MediaList) => ({
        ...prevFileList,
        photo1: uploadedFile,
      }));
    }
  };

  const handleDeletePhoto1Image = () => {
    Files.ImageAPI.Delete(fileList?.photo1, setFileList, setPhoto1Url);
  };

  return {
    photo1Image,
    handlePhoto1ImageChange,
    handleAttachPhoto1Image,
    handleDeletePhoto1Image,
  };
};
